import { render, staticRenderFns } from "./DetailsWrapper.vue?vue&type=template&id=0e7d2d05&"
import script from "./DetailsWrapper.vue?vue&type=script&lang=js&"
export * from "./DetailsWrapper.vue?vue&type=script&lang=js&"
import style0 from "./DetailsWrapper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports